module.exports = {
  name: 'Obras',
  desc: 'Televisa - obras',
  prefix: 'obras',
  footerText: 'Televisa obras | Todos los derechos reservados 2018',
  logoText: 'Obras',
  needLogin: false
};
